import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {Link} from 'react-router';
import SubscriptionContainer from 'modules/Common/containers/Subscriptions/SubscriptionContainer';
import MyStableButton from 'modules/Common/containers/Subscriptions/MyStableButton';
import BetLink from 'modules/Common/containers/BetLink';
import CaretIcon from 'modules/Common/components/svg/CaretIcon';
import { racecardResultHref, rideDetailsFromEntry } from 'modules/HorseRacing/utils';
import { TODAYS_RIDES_STRING, TODAYS_ENTRIES_STRING } from 'modules/HorseRacing/consts';

export default class HorseRacingAbcPersonEntry extends Component {
  static propTypes = {
      entry: PropTypes.array,
      tableType: PropTypes.string
  }

  constructor() {
    super();
    this.state = {rideTableOpen: false};
  }

  showRideRow(entry) {
    const {
      ride: {
        ride_reference: {
          id: rideId
        },
        horse: {
          horse_reference: {
            id: horseId
          },
          name: horseName
        },
        betting: {
          current_odds: odds
        },
        jockey: {
          person_reference: {
            id: jockeyId
          },
          name: jockeyName
        },
        trainer: {
          business_reference: {
            id: trainerId
          },
          name: trainerName
        }
      }
    } = entry;

    const entryDetails = rideDetailsFromEntry(entry);

    return <span key={rideId} className="abc-guide-person-row">
      <div className="abc-guide-ride-race">
        <Link to={racecardResultHref(entryDetails.raceLinkDetails)}>{entryDetails.raceLinkDetails.eventName}</Link>
      </div>
      <div className="abc-guide-ride-horse">
        <Link to={`/racing/profiles/horse/${horseId}`}>{horseName}</Link>
      </div>
      <div className="abc-guide-ride-person jockey">
        <Link to={`/racing/profiles/trainer/${trainerId}`}>{trainerName}</Link>
      </div>
      <div className="abc-guide-ride-person trainer">
        <Link to={`/racing/profiles/jockey/${jockeyId}`}>{jockeyName}</Link>
      </div>
      <div className="abc-guide-ride-odds">
        { !!entryDetails.betlinkProps &&
          <BetLink className='hr-racing-runner-betting-link sui-odds' {...entryDetails.betlinkProps}>{odds}</BetLink>
        }
      </div>
    </span>;
  }

  toggleRidesOpen() {
    this.setState({
      rideTableOpen: !this.state.rideTableOpen
    })
  }

  render() {
    const {
      entry: [{
        ride: {
          jockey: {
            name: jockeyName,
            person_reference: {
              id: jockeyId
            }
          },
          trainer: {
            name: trainerName,
            business_reference: {
              id: trainerId
            }
          }
        }
      }],
      tableType
    } = this.props;

    require('./HorseRacingAbcGuideEntry.scss');
    
    return <span key={jockeyId} className="abc-guide-person-row">
        <div className="abc-guide-person-name jockey">
          <Link to={`/racing/profiles/jockey/${jockeyId}`}>{jockeyName}</Link>
        </div>
        <div className="abc-guide-my-stable jockey">
          <SubscriptionContainer
            addSubscriptions={ [{ type: "JOCKEY", id: jockeyId, text: jockeyName }] }
            icon={ <MyStableButton noText/> } />
        </div>
        <div className="abc-guide-person-name trainer">
          <Link to={`/racing/profiles/trainer/${trainerId}`}>{trainerName}</Link>
        </div>
        <div className="abc-guide-my-stable trainer">
          <SubscriptionContainer
              addSubscriptions={ [{ type: "TRAINER", id: trainerId, text: trainerName }] }
              icon={ <MyStableButton noText/> } />
        </div>
        <div className="abc-guide-todays-rides" onClick={() => this.toggleRidesOpen()}>
          <CaretIcon type="full" direction={this.state.rideTableOpen ? "up" : "down"}/>
          <label>{tableType == "jockeys" ? TODAYS_RIDES_STRING : TODAYS_ENTRIES_STRING}</label>
        </div>
        {this.state.rideTableOpen && <div className="abc-guide-ride-table">
          <span className="abc-guide-person-row">
            <div className="abc-guide-ride-race subHeader">Race</div>
            <div className="abc-guide-ride-horse subHeader">Horse</div>
            <div className="abc-guide-ride-person jockey subHeader">Trainer</div>
            <div className="abc-guide-ride-person trainer subHeader">Jockey</div>
            <div className="abc-guide-ride-odds subHeader">Odds</div>
          </span>
          {this.props.entry.map(this.showRideRow)}
        </div>}
      </span>;
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingAbcPersonEntry.js